import { DOCUMENT } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ForgotLoginScreenContent } from './modals/forgot-login.interface';

@Component({
  selector: 'idp-forgot-login',
  templateUrl: './forgot-login.component.html',
  styleUrls: ['./forgot-login.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ForgotLoginComponent implements OnDestroy, OnInit {
  @Input() forgotLoginContent!: ForgotLoginScreenContent | undefined | null;
  @Input() callBackFunction!: () => void;
  @Input() fromStandAlone = false;
  @Output() formSubmitEvent: EventEmitter<ElementRef> =
    new EventEmitter<ElementRef>();

  @Output() focusInvalidField: EventEmitter<string> =
    new EventEmitter<string>();

  @Output() fieldFocusOut: EventEmitter<string> = new EventEmitter<string>();
  @Output() closeOverlayMessage: EventEmitter<void> = new EventEmitter();
  @Output() inputChange: EventEmitter<string> = new EventEmitter<string>();

  form!: UntypedFormGroup;

  constructor(@Inject(DOCUMENT) private document: Document) {}

  ngOnInit() {
    if (this.document !== undefined) {
      this.document.addEventListener('akamai-challenge-noreload', () => {
        this.submit();
      });
    }
  }

  get showEmailIdErrorMessage() {
    const control: UntypedFormControl = <UntypedFormControl>(
      this.forgotLoginContent?.formGroup?.get('emailId')
    );
    return (
      control &&
      this.forgotLoginContent?.forgotLoginAttributes?.emailIdControlTouched &&
      control.invalid
    );
  }

  get showFirstNameErrorMessage() {
    const control: UntypedFormControl = <UntypedFormControl>(
      this.forgotLoginContent?.formGroup?.get('firstName')
    );
    return (
      control &&
      this.forgotLoginContent?.forgotLoginAttributes?.firstNameControlTouched &&
      control.invalid
    );
  }

  get showLastNameErrorMessage() {
    const control: UntypedFormControl = <UntypedFormControl>(
      this.forgotLoginContent?.formGroup?.get('lastName')
    );
    return (
      control &&
      this.forgotLoginContent?.forgotLoginAttributes?.lastNameControlTouched &&
      control?.invalid
    );
  }

  firstInvalidFieldFocusEvent() {
    this.focusInvalidField.emit();
  }

  onChange() {
    this.inputChange.emit();
  }

  onFocussedOut(fieldName: string) {
    this.fieldFocusOut.emit(fieldName);
  }

  submit() {
    this.formSubmitEvent.emit();
  }

  onClosePop() {
    this.closeOverlayMessage.emit();
  }

  ngOnDestroy(): void {
    this.callBackFunction();
  }
}
